import { useCallback, useContext } from "react"
import ApplicationContext from "../context"

export const useLoader = () => {
    const { setState } = useContext(ApplicationContext)
    return useCallback(show => {
        setState(prev => {
            const val = show ? prev.counter + 1 : Math.max(0, prev.counter - 1)
            if (window.optima && window.optima.UI) {
                if (val > 0) {
                    window.optima.UI.loader.show()
                } else {
                    window.optima.UI.loader.hide()
                }
            }
            return {
                ...prev,
                loader: val > 0,
                counter: val
            }
        })
    }, [])
}